import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcDesign = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "m7.553 14.543-3-3 9.293-9.293a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414l-9.293 9.293Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M2.634 17.11a.5.5 0 0 1-.65-.65l1.567-3.917 3 3-3.917 1.567Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.76 20.336c-.63.63-.184 1.707.707 1.707h13.586a1 1 0 0 0 1-1v-1.875h-1a.625.625 0 0 1 0-1.25h1v-1.25h-.5a.625.625 0 0 1 0-1.25h.5v-1.25h-1a.625.625 0 0 1 0-1.25h1v-1.25h-.5a.625.625 0 0 1 0-1.25h.5v-2.96c0-.892-1.078-1.338-1.707-.708L6.76 20.336Zm11.793-6.843-5.05 5.05h5.05v-5.05Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
})), "IcDesign");

export { IcDesign };
//# sourceMappingURL=ic-design.js.map
